// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Rkiq","delete":"styles_delete__3cAY3","update":"styles_update__3bHCe","add":"styles_add__3EdEx"};